module.exports = __webpack_public_path__ + "static/media/icon-terrain.575869d1.svg";